import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { OfficialGuachincheBadge, KidsBadge } from '@/components/PlaceBadges';
import { OpenStatusBadge } from '@/components/OpenStatusBadge';

const PlaceCard = ({ place, showDistance = true }) => {
  const { getLocalizedField } = useLanguage();
  const navigate = useNavigate();

  const name = getLocalizedField(place, 'name');
  const address = place.address || 'Tenerife';

  return (
    <div
      className="card-flat cursor-pointer group"
      onClick={() => navigate(`/place/${place.id}`)}
      data-testid={`place-card-${place.id}`}
    >
      {/* Image */}
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={place.images?.[0] || 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800'}
          alt={name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        
        {/* Badges: guachinche oficial + niños (se apilan si no caben) */}
        {(place.kids_friendly || place.official_guachinche) && (
          <div className="absolute top-2 right-2 flex flex-col items-end gap-1">
            {place.official_guachinche && <OfficialGuachincheBadge testId={`official-badge-${place.id}`} />}
            {place.kids_friendly && <KidsBadge testId={`kids-badge-${place.id}`} />}
          </div>
        )}
        
        {/* Distance badge */}
        {showDistance && place.distance !== undefined && (
          <div className="distance-badge">
            {place.distance < 1 
              ? `${Math.round(place.distance * 1000)} m` 
              : `${place.distance} km`}
          </div>
        )}
      </div>

      {/* Content - Minimal */}
      <div className="p-3">
        <h3 className="font-semibold text-gray-900 text-sm mb-1 line-clamp-1">
          {name}
        </h3>
        
        <div className="flex items-center gap-1 text-gray-500">
          <MapPin size={12} />
          <span className="text-xs line-clamp-1">{address}</span>
        </div>
        <div className="mt-1"><OpenStatusBadge openingHours={place.opening_hours} placeId={place.id} /></div>
      </div>
    </div>
  );
};

export default PlaceCard;
